<template>
  <div class="Crisis_addmajor_event">
    <el-form style="padding-top: 20px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="学生学号" prop="userId">
        <el-input :disabled="true" v-model="ruleForm.userId"></el-input>
      </el-form-item>

      <el-form-item label="学生姓名" prop="realName">
        <el-input :disabled="true" v-model="ruleForm.realName"></el-input>
      </el-form-item>

      <el-form-item label="预警人">
        <el-input :disabled="true" v-model="ruleForm.alertName"></el-input>
      </el-form-item>

      <el-form-item label="预警人电话">
        <el-input :disabled="true" v-model="ruleForm.alertPhone"></el-input>
      </el-form-item>

      <el-form-item label="自杀他杀风险详情" class="nkjs">
        <el-input :disabled="true" type="textarea" v-model="ruleForm.difficultDetail"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">"五困"类型及具体表现</h2>

      <el-form-item class="difficulty" label="学习困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.studyDifficulty">
          <el-checkbox  label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox  label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox  label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox  label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox  label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox  label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox  label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox  label="8" name="type">留级延期</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:30px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px;position: absolute;top: 2px;right: -10px;" v-model="studyDifficultyOther" placeholder="请输入学习困扰"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="生活困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.lifeDifficulty">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:0px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px;position: absolute;top: 2px;right: -40px;" v-model="lifeDifficultyOther" placeholder="请输入生活困难"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="交往困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.contactDifficulty">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:0px;display: block;color: #606266;">其他</span>
        <el-input v-model="contactDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: -40px;" placeholder="请输入交往困难"></el-input>
      </el-form-item>
            <!-- studyDifficultyOther: '',
          lifeDifficultyOther: '',
          contactDifficultyOther: '',
          developDifficultyOther: '',
          psyDifficultyOther: '', -->
      <el-form-item class="difficulty" label="发展困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.developDifficulty">
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:130px;display: block;color: #606266;">其他</span>
        <el-input v-model="developDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: 90px;" placeholder="请输入发展困难"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.psyDifficulty">
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
        </el-checkbox-group>
  <span style="width: 200px;position: absolute;top: 0px;right:80px;display: block;color: #606266;">其他</span>
        <el-input v-model="psyDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: 40px;" placeholder="请输入心理困难"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      KeyNo: '',
      pdtcbx: true,
      pdtcbx2: true,
      pdtcbx9: true,//是否在心理中心咨询
      radio: '1',
      lifeDifficultyOther: '',
      studyDifficultyOther: '',
      contactDifficultyOther: '',
      developDifficultyOther: '',
      psyDifficultyOther: '',
      ruleForm: {
        difficultDetail: '',//严重心理困扰表现
        alertName: '',//预警人
        alertPhone: '',//预警人电话
        userId: '',//学生学号
        realName: '',//学生姓名
        studyDifficulty: [],//学生困难
        lifeDifficulty: [],//生活困难
        contactDifficulty: [],//交往困难 
        developDifficulty: [],//发展困难
        psyDifficulty: [],//心理困难
        discovery: [],//发展途径
      },
      rules: {
        userId: [
          { required: true, message: '请输入学生学号', trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        psychCentralSuggest: [
          { type: 'array', required: true, message: '请至少选择一个心理中心建议', trigger: 'change' }
        ],
      }
    };
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    this.KeyNo = [this.$route.query.KeyNo];
    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', { keyNo: this.KeyNo[0] }).then((res) => {
      if (res.Code == 0) {
        this.ruleForm.userId = res.Data.userId;
        this.ruleForm.realName = res.Data.realName;
        this.ruleForm.alertName = res.Data.alertName;
        this.ruleForm.alertPhone = res.Data.alertPhone;
        this.ruleForm.difficultDetail = res.Data.difficultDetail;
        for (let i = 0; i <= res.Data.studyDifficultys.length; i++) {
            this.studyDifficultyOther = res.Data.studyDifficultyOther;
            this.ruleForm.studyDifficulty = res.Data.studyDifficultys;

        }
        for (let i = 0; i <= res.Data.lifeDifficultys.length; i++) {
 
            this.lifeDifficultyOther = res.Data.lifeDifficultyOther;
            this.ruleForm.lifeDifficulty = res.Data.lifeDifficultys;

        }
        for (let i = 0; i <= res.Data.contactDifficultys.length; i++) {

            this.contactDifficultyOther = res.Data.contactDifficultyOther;
            this.ruleForm.contactDifficulty = res.Data.contactDifficultys;

        }
        for (let i = 0; i <= res.Data.developDifficultys.length; i++) {
            this.developDifficultyOther = res.Data.developDifficultyOther;
            this.ruleForm.developDifficulty = res.Data.developDifficultys;

        }
        for (let i = 0; i <= res.Data.psyDifficultys.length; i++) {
            this.psyDifficultyOther = res.Data.psyDifficultyOther;
            this.ruleForm.psyDifficulty = res.Data.psyDifficultys;
        }
      }
    });
  }
}
</script>

<style>
  .Crisis_addmajor_event{width: 100%;background-color: rgb(255, 255, 255);height: 100%;}
  .Crisis_addmajor_event .el-input{width: 240px;}
  .Crisis_addmajor_event .quz .el-form-item__content{margin-left: 20px !important;}
  .Crisis_addmajor_event .bgfbf .el-form-item__label{width: 150px !important;}
  .Crisis_addmajor_event .hjoi .el-form-item__label{width: 180px !important;}
  .Crisis_addmajor_event .bgssfbf .el-form-item__label{width: 492px !important;}
  .Crisis_addmajor_event .huhxs .el-form-item__label{width: 172px !important;}
  .Crisis_addmajor_event .huhxsxs .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .suicidalFlg .el-form-item__label{width: 210px !important;}
  .Crisis_addmajor_event .psychosesFlg  .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .InjuryDetails  .el-form-item__label{width: 275px !important;}
  .Crisis_addmajor_event .InjuryDetails  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p1 .el-form-item__label{width: 170px !important;}
  .Crisis_addmajor_event .p2 .el-form-item__label{width: 130px !important;}
  .Crisis_addmajor_event .p3 .el-form-item__label{width: 142px !important;}
  .Crisis_addmajor_event .p4 .el-form-item__label{width: 156px !important;}
  .Crisis_addmajor_event .p5 .el-form-item__label{width: 200px !important;}
  .Crisis_addmajor_event .p5  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p6 .el-form-item__label{width: 186px !important;}
  .Crisis_addmajor_event .p6  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p7 .el-form-item__label{width: 176px !important;}

  .Crisis_addmajor_event .difficulty{width: 1400px !important;}

  .Crisis_addmajor_event .nkjs .el-textarea.is-disabled .el-textarea__inner{width: 500px !important;height: 80px;}
</style>